// Almikia CRM is a Mexican Spanish application: dates dd/mm/aaaa, currency MXN
export const APP_LOCALE = "es-MX";

// Numeric date format (dd/mm/aaaa) for Intl.DateTimeFormat
export const NUMERIC_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
